/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AreaOfInterestCreate = {
    properties: {
        key: {
            type: 'string',
            isRequired: true,
        },
        name: {
            type: 'TranslationCreate',
            isRequired: true,
        },
        display: {
            type: 'boolean',
            isRequired: true,
        },
        regionId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
